export const atCheckboxMockData = {
  label: '3D Available',
  name: 'filter-options',
  value: '3d-available',
  checked: false,
};
